import React from "react";
import {Drawer, IconButton} from "@mui/material";
import {sidebarClass, shield} from "../../resources/environment";
import {useSidebarLayout} from "./Context/SidebarProvider";
import {SidebarContent} from "./SidebarContent";
import {useSidebarStyles} from "./sidebarStyles";

export const SidebarNew = () => {
  const {isSidebarHidden, xsScreen, isSidebarExpanded, toggleSidebar} = useSidebarLayout();
  const {classes} = useSidebarStyles({isSidebarExpanded});
  const sidebarHiddenClass = isSidebarHidden && xsScreen ? `${sidebarClass}` : "";

  return (
    <>
      {isSidebarHidden && xsScreen && (
        <IconButton
          onClick={toggleSidebar}
          aria-label="Open sidebar"
          className={classes.mobileMenuButton}
        >
          <img src={shield} alt="BreachRx" style={{height: 24}} />
        </IconButton>
      )}
      <nav
        aria-label="Main navigation"
        className={`${classes.root} ${sidebarHiddenClass}`}
        id="sidebar"
      >
        <Drawer
          className={`${classes.drawer} ${sidebarHiddenClass}`}
          variant="permanent"
          classes={{paper: `${classes.drawerPaper} main-sidebar-drawer`}}
        >
          <div id="sidebar-content" className={classes.sidebarContent}>
            <SidebarContent />
          </div>
        </Drawer>
      </nav>
    </>
  );
};
